import { Link, NavLink } from 'react-router-dom';
import { useApp } from '../context/AppContext.jsx';
import { cx } from '../lib/util.js';
import { LiveBadge } from './ui.jsx';
import strawberryLogo from '../assets/strawberry-logo.svg';

const LINKS = [
  { to: '/shift', label: 'Shift Calculator' },
  { to: '/audit', label: 'Inventory Audit' },
  { to: '/skyads', label: 'Skyads' },
  { to: '/lifeinvader', label: 'Lifeinvader' },
  { to: '/partner', label: 'LS Ball' },
  { to: '/manager', label: 'Manager' },
];

export function NavBar() {
  const { managerAuthed, logout, lastSync } = useApp();

  return (
    <header className="sticky top-0 z-40 border-b border-edge bg-surface/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
        <Link to="/shift" className="flex shrink-0 items-center gap-3">
          <span className="grid h-9 w-9 place-items-center overflow-hidden">
            <img src={strawberryLogo} alt="Strawberry Gas" draggable={false} className="h-full w-full object-cover" />
          </span>
          <span className="hidden font-mono text-sm font-bold uppercase tracking-[0.3em] text-snow sm:inline">
            Strawberry<span className="text-neon">Gas</span>
          </span>
        </Link>

        <nav className="flex min-w-0 items-center gap-1 overflow-x-auto">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                cx(
                  'whitespace-nowrap px-3 py-2 font-mono text-[11px] uppercase tracking-widest transition-colors',
                  isActive
                    ? 'text-neon underline underline-offset-8'
                    : 'text-mist hover:text-snow'
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
          <div className="ml-1 flex items-center gap-2 pl-2">
            <LiveBadge lastSync={lastSync} />
            {managerAuthed && (
              <button
                onClick={logout}
                title="Log out of manager session"
                className="border border-ember/60 px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-widest text-ember transition-colors hover:bg-ember/10"
              >
                Logout
              </button>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
}